import { Link } from 'react-router-dom';
import { softwareList, type SoftwareItem } from '@/mocks/software';

export default function HotDownloads() {
  const hotItems: SoftwareItem[] = softwareList.filter((item) => item.isHot).slice(0, 8);

  return (
    <section className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              热门下载推荐
            </h2>
            <p className="text-foreground-500 text-sm">
              千万用户的选择，大家都在下载这些热门资源
            </p>
          </div>
          <Link
            to="/category/software"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {hotItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500 transition-colors duration-300">
                  <i className={`${item.icon} text-lg text-primary-600 group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.name}</h3>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-foreground-400">{item.version}</span>
                    <span className="text-xs text-foreground-300">·</span>
                    <span className="text-xs text-foreground-400">{item.size}</span>
                  </div>
                </div>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                {item.desc}
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1">
                  <div className="flex">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${
                          i < Math.floor(item.rating)
                            ? 'ri-star-fill text-primary-500'
                            : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                  <span className="text-xs text-foreground-400 ml-1">{item.rating}</span>
                </div>
                <span className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white text-xs font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  <i className="ri-download-2-line"></i>
                  下载
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/software"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}